import React from 'react';
import { SlideLayout } from './SlideLayout';
import { Star } from 'lucide-react';
export function Slide7_Tiers() {
  const tiers = [{
    name: 'EDGE',
    role: 'Infrastructure',
    description: 'Predictable applicant flow and pre-screening.',
    keyPoints: ['HIRE handles traffic and screening', 'You handle interviews and hiring'],
    bestFor: 'Teams with strong internal hiring who want better candidates.'
  }, {
    name: 'ADVANTAGE',
    role: 'System Ownership',
    description: 'A recruiting system that actually works.',
    keyPoints: ['Campaign success ambassadors', 'Campaign success manager', 'Two-day live sales school', 'Active KPI tracking', 'Ongoing consulting and campaign performance enhancement'],
    highlight: true,
    bestFor: 'Teams that want consistency without giving up execution.'
  }, {
    name: 'SUMMIT',
    role: 'Full Execution',
    description: 'Recruiting execution handled for you.',
    keyPoints: ['Dedicated recruiter capacity', 'Interview execution and scheduling'],
    bestFor: 'Teams that want recruiting off their plate.'
  }];
  return <SlideLayout data-id="element-204">
      <div className="flex flex-col h-full justify-center space-y-16" data-id="element-205">
        <div className="space-y-4 text-center" data-id="element-206">
          <h2 className="text-4xl md:text-5xl font-bold text-white" data-id="element-207">
            Three Levels of Partnership
          </h2>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto" data-id="element-208">
            Designed to Support Where Your Business Is At Now and In the Future.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center max-w-6xl mx-auto" data-id="element-209">
          {tiers.map((tier, idx) => <div key={idx} className={`flex flex-col rounded-xl border transition-all relative ${tier.highlight ? 'bg-slate-800/50 border-emerald-500/50 ring-2 ring-emerald-500/20 md:scale-110 shadow-2xl' : 'bg-slate-900/30 border-slate-800'} p-8`} data-id="element-210">
              {tier.highlight && <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 bg-emerald-500 text-slate-950 text-xs font-bold uppercase tracking-wider rounded-full flex items-center space-x-1.5" data-id="element-211">
                  <Star size={12} fill="currentColor" data-id="element-212" />
                  <span data-id="element-213">Most Popular</span>
                </div>}

              <div className="mb-6" data-id="element-214">
                <h3 className="text-3xl font-bold text-white mb-3" data-id="element-215">
                  {tier.name}
                </h3>
                <span className={`inline-block px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider ${tier.highlight ? 'bg-emerald-500/20 text-emerald-400' : 'bg-slate-800 text-slate-400'}`} data-id="element-216">
                  {tier.role}
                </span>
              </div>

              <p className="text-slate-300 text-lg mb-8 leading-relaxed" data-id="element-217">
                {tier.description}
              </p>

              <div className="space-y-3 mb-8 flex-1" data-id="element-218">
                {tier.keyPoints.map((point, pIdx) => <div key={pIdx} className="flex items-start" data-id="element-219">
                    <span className={`mr-3 mt-1.5 h-1.5 w-1.5 rounded-full flex-shrink-0 ${tier.highlight ? 'bg-emerald-500' : 'bg-slate-600'}`} data-id="element-220" />
                    <span className="text-slate-300" data-id="element-221">{point}</span>
                  </div>)}
              </div>

              <div className="pt-6 border-t border-slate-800" data-id="element-222">
                <p className="text-sm text-slate-400 leading-relaxed" data-id="element-223">
                  {tier.bestFor}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </SlideLayout>;
}